import React from "react"
import { StaticQuery, Link, graphql } from "gatsby"
import styles from "./bandeau.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function brandeau({ title, link_texte, link_route }) {
  return (
    <div className="row">
      <div
        className={`col-lg-12 d-flex align-items-center justify-content-center ${
          styles.bg
        } `}
      >
        <h4 className={`m-0 p-0 mr-2 ${styles.h4}`}>{title}</h4>
        <Link to={link_route} className="btn-action-3">
          <FontAwesomeIcon icon="question-circle" />
          {link_texte}
        </Link>
      </div>
    </div>
  )
}

export default brandeau
